import { render, staticRenderFns } from "./viewCoupon.vue?vue&type=template&id=74477525&scoped=true"
import script from "./viewCoupon.vue?vue&type=script&lang=js"
export * from "./viewCoupon.vue?vue&type=script&lang=js"
import style0 from "./viewCoupon.vue?vue&type=style&index=0&id=74477525&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74477525",
  null
  
)

export default component.exports